/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKBadge from "components/MKBadge";
import MKTypography from "components/MKTypography";

// Presentation page components
import ExampleCard from "pages/Presentation/components/ExampleCard";

// Data
import data from "pages/Presentation/sections/data/designBlocksData";

function DesignBlocks() {
  const renderData = data.map(({ title, description, items }) => (
    <Grid container spacing={3} sx={{ mb: 10 }} key={title}>
      <Grid item xs={12} lg={3}>
        <MKBox position="sticky" top="100px" pb={{ xs: 2, lg: 6 }}>
          <MKTypography variant="h3" fontWeight="bold" mb={1} sx={{ color: "#1d910eff" }}>
            {title}
          </MKTypography>
          <MKTypography variant="body2" fontWeight="regular" color="secondary" mb={1} pr={2}>
            {description}
          </MKTypography>
          <Link to={items[0]?.route || "/"} style={{ textDecoration: "none" }}>
            <MKBox
              sx={{
                position: "relative",
                display: "inline-block",
                backgroundColor: "#1d910eff",
                color: "#ffffff",
                borderRadius: "8px",
                px: 4,
                py: 1.5,
                fontWeight: "bold",
                fontSize: "1rem",
                cursor: "pointer",
                overflow: "hidden",
                transition: "all 0.3s ease",
                "&:before": {
                  content: '""',
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  width: "0",
                  height: "0",
                  borderRadius: "50%",
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  transform: "translate(-50%, -50%)",
                  transition: "width 0.6s, height 0.6s",
                },
                "&:hover:before": {
                  width: "300px",
                  height: "300px",
                },
                "&:hover": {
                  boxShadow: "0 10px 25px rgba(29, 145, 14, 0.4)",
                  transform: "translateY(-3px)",
                },
                "& span": {
                  position: "relative",
                  zIndex: 1,
                },
              }}
            >
              <span>Découvrir plus →</span>
            </MKBox>
          </Link>
        </MKBox>
      </Grid>
      <Grid item xs={12} lg={9}>
        <Grid container spacing={3} justifyContent="center">
          {items.map(({ image, name, count, route, pro }) => (
            <Grid item xs={12} md={6} sx={{ mb: 2 }} key={name}>
              <Link to={pro ? "/" : route}>
                <ExampleCard image={image} name={name} count={count} pro={pro} />
              </Link>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  ));

  return (
    <MKBox component="section" my={5} py={5}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          flexDirection="column"
          alignItems="center"
          sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
        >
          <MKBadge
            variant="contained"
            color="info"
            badgeContent="REALISATIONS"
            container
            sx={{ mb: 2 }}
          />
          <MKTypography variant="h2" fontWeight="bold" sx={{ color: "#1d910eff" }}>
            Nos differentes réalisations
          </MKTypography>
          <MKTypography variant="body1" color="text">
            ANEMAR GROUPE vous presente quelques unes de ses réalisations dans divers domaines.
          </MKTypography>
        </Grid>
      </Container>
      <Container sx={{ mt: 6 }}>{renderData}</Container>
    </MKBox>
  );
}

export default DesignBlocks;
